import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-load',
  templateUrl: './view-load.component.html',
  styleUrls: ['./view-load.component.sass']
})
export class ViewLoadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

}
